import { render, staticRenderFns } from "./informationIndex.vue?vue&type=template&id=55276c42&scoped=true&"
import script from "./informationIndex.vue?vue&type=script&lang=js&"
export * from "./informationIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=55276c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55276c42",
  null
  
)

export default component.exports